module.exports = __webpack_public_path__ + "img/pager2-quick-icon9.42ce856e.png";